export const tag = 'locationsTemplate';
export const load = async () => {
    const { LocationsComponent } = await import('./locations.component');
    return {
        component: LocationsComponent,
    };
};
